import React from 'react';
import { Shield, Lock, CheckCircle, AlertTriangle } from 'lucide-react';

const EncryptionStatus = ({ level, screenshotPrevention, anonymousMode }) => {
  const getEncryptionInfo = () => {
    switch (level) {
      case 'basic':
        return {
          icon: <Shield className="w-4 h-4 text-gray-500" />,
          label: 'Basique',
          color: 'text-gray-600',
          bgColor: 'bg-gray-50',
          description: 'TLS Standard'
        };
      case 'standard':
        return {
          icon: <Lock className="w-4 h-4 text-blue-500" />,
          label: 'Standard',
          color: 'text-blue-600',
          bgColor: 'bg-blue-50',
          description: 'E2E Encryption'
        };
      case 'high':
        return {
          icon: <Shield className="w-4 h-4 text-green-500" />,
          label: 'Élevé',
          color: 'text-green-600',
          bgColor: 'bg-green-50',
          description: 'AES-256'
        };
      case 'enterprise':
        return {
          icon: <Lock className="w-4 h-4 text-purple-500" />,
          label: 'Entreprise',
          color: 'text-purple-600',
          bgColor: 'bg-purple-50',
          description: 'HSM Protected'
        };
      default:
        return {
          icon: <AlertTriangle className="w-4 h-4 text-orange-500" />,
          label: 'Non sécurisé',
          color: 'text-orange-600',
          bgColor: 'bg-orange-50',
          description: 'Aucun chiffrement'
        };
    }
  };

  const encryptionInfo = getEncryptionInfo();

  return (
    <div className="space-y-3">
      <div className={`${encryptionInfo?.bgColor} border border-current/20 rounded-lg p-3`}>
        <div className="flex items-center space-x-2 mb-2">
          {encryptionInfo?.icon}
          <span className={`font-medium text-sm ${encryptionInfo?.color}`}>
            Chiffrement {encryptionInfo?.label}
          </span>
          <CheckCircle className="w-4 h-4 text-current" />
        </div>
        <p className={`text-xs ${encryptionInfo?.color} opacity-80`}>
          {encryptionInfo?.description}
        </p>
      </div>

      <div className="space-y-2">
        {screenshotPrevention && (
          <div className="flex items-center space-x-2 text-xs text-green-600">
            <CheckCircle className="w-3 h-3" />
            <span>Protection capture d'écran active</span>
          </div>
        )}
        
        {anonymousMode && (
          <div className="flex items-center space-x-2 text-xs text-blue-600">
            <CheckCircle className="w-3 h-3" />
            <span>Mode anonyme activé</span>
          </div>
        )}
        
        <div className="flex items-center space-x-2 text-xs text-gray-500">
          <CheckCircle className="w-3 h-3" />
          <span>Coordonnées masquées par défaut</span>
        </div>
      </div>
    </div>
  );
};

export default EncryptionStatus;